import { contractStatusValue } from '@/views/erp/base/contractManage/enum'
import { useAccountStore } from '@/stores/modules/account'
import { router } from '@/router'
import { useResource } from '@/hooks/useResource'
import {
  downloadContractFile,
  loopGetContractFile,
  afterSaveView,
  preSaveView,
  previewRescission
} from '@/apis/erp/contractManage'
import { saveAs } from 'file-saver'

/**
 * 合同按钮权限控制
 * @param code
 * @param status 合同状态
 * @param selfData 是否为本机构自建的合同 1：是，2：否
 */
export function getBtnShowByStatus(code: string, status: number, selfData: 1 | 2): boolean {
  const { getAuthByMenuCode } = useResource()
  if (!getAuthByMenuCode('ContractManage', code)) return false
  const noSelfHidden = ['SENDCONTRACT', 'EDIT', 'DELETE', 'REVOCATION', 'RESEND']
  if (selfData === 2 && noSelfHidden.includes(code)) return false
  switch (status) {
    case contractStatusValue.unSend:
      return ['SENDCONTRACT', 'PREVIEW', 'EDIT', 'DELETE'].includes(code)
    case contractStatusValue.signing:
      return ['REVOCATION'].includes(code)
    case contractStatusValue.finish:
      return ['DOWNLOAD', 'PRINT', 'BREAK_OFF', 'LOOK_BREAK_OFF'].includes(code)
    case contractStatusValue.revoke:
      return ['DELETE', 'RESEND'].includes(code)
    case contractStatusValue.reject:
      return ['DELETE'].includes(code)
    case contractStatusValue.fail:
      return ['RESEND', 'PREVIEW', 'EDIT', 'DELETE'].includes(code)
    case contractStatusValue.overdue:
      return ['DELETE'].includes(code)
    case contractStatusValue.nullify:
      return ['LOOK_BREAK_OFF', 'DOWNLOAD'].includes(code)
    default:
      return false
  }
}

export function noAuthDialog(fn?: Fn) {
  const accountStore = useAccountStore()
  const userInfo = accountStore.userInfo
  ElMessageBox.confirm(
    userInfo.isAdmin
      ? '请在“机构中心”做企业实名认证'
      : '机构未做实名认证，请联系管理员在“机构中心”做企业实名认证',
    '提示',
    {
      confirmButtonText: userInfo.isAdmin ? '去认证' : '确定'
    }
  ).then(() => {
    if (userInfo.isAdmin) {
      router.push('/accountConfig?active=second&formPage=contractManage')
    }
    fn && fn()
  })
}

/**
 * 下载合同
 * @param id 合同id
 * @param type 合同类型 sign.原合同 remove.解约合同
 */
export async function downLoadContract(id: string | number, type: 'sign' | 'remove') {
  try {
    const res = await downloadContractFile({
      id,
      contractFunctionType: type === 'remove' ? 2 : 1
    })
    if (res.downloadUrl) {
      saveAs(res.downloadUrl, res.fileName)
    } else if (res.reportId) {
      // 区块链存证  需要轮询
      const data: string = await loopGetContractFile({ reportId: res.reportId })
      saveAs(data)
    }
  } catch (e: any) {
    console.log('wwwww', e)
    ElMessage.error(e.message)
    throw e
  }
}

export async function previewContract(info: Recordable) {
  try {
    let api = afterSaveView
    if (info.status === contractStatusValue.unSend || info.status === contractStatusValue.fail) {
      api = preSaveView
    }
    let url = await api({ id: info.id })
    window.open(url)
  } catch (e) {
    console.log(e)
  }
}
